import React, { Component, PropTypes } from 'react';
import { withRouter } from 'react-router';
import StudentStore from 'stores/Student';
import GroupStore from 'stores/Group';
import CourseStore from 'stores/Course';
import {
  GroupActions,
  CourseActions,
  StudentActions,
  UserActions,
  StudentOverviewActions
} from 'actions';
import SimpleOverview from 'components/Widgets/SimpleOverview';
import {
  TextField,
  List,
  ListItem,
  Toolbar,
  ToolbarTitle,
  Toggle,
  ToolbarGroup,
  Dialog,
  Styles
} from 'material-ui';
import Const from 'Constants';
import Message from 'services/Message';
import InviteActions from 'actions/Invite';
import { FormattedRelative, FormattedMessage } from 'react-intl';
import { mixin, RefluxMixin } from 'Util';
import Tag from 'components/Tag';
import CourseSelector from 'components/CourseSelector';
import GroupSelector from 'components/GroupSelector';
import DialogPortal from 'components/DialogPortal';
import DropDown from 'components/Material/DropDown';

import ScrollableContainer from 'components/ScrollableContainer';
import Overview from 'components/Widgets/Overview';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import * as MaterialIcons from 'components/Material/SvgIcons';
import * as CoursioIcons from 'components/Icons';

const { Spacing } = Styles;

class StudentDetail extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    router: PropTypes.object,
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      accessTime: null,
      selectedCourse: {
        name: context.getIntlMessage('course.noSelected')
      },
      selectedGroup: { name: context.getIntlMessage('group.noSelected') },
      selectedStudent: {
        name: context.getIntlMessage('student.noSelected')
      },
      rolesValue: this.props.student.roles.value,
      progress: []
    };
    this.accessTimes = {
      oneMonth: context.getIntlMessage('invite.oneMonth'),
      threeMonths: context.getIntlMessage('invite.threeMonths'),
      sixMonths: context.getIntlMessage('invite.sixMonths'),
      oneYear: context.getIntlMessage('invite.oneYear'),
    };
    this.menuItems = [
      {
        payload: null,
        text: context.getIntlMessage('invite.chooseAccessTime')
      }
    ];
    Object.keys(this.accessTimes).forEach(time => {
      this.menuItems.push({ payload: time, text: this.accessTimes[time] });
    });
  }

  listenToStores() {
    this.listenToStore(GroupStore, 'group');
    this.listenToStore(CourseStore, 'course');
    this.listenToStore(StudentStore, 'student');
  }

  componentDidMount() {
    const { student } = this.props;
    GroupActions.findByUserId(student.id);
    CourseActions.findByUserId(student.id);

    SteelCompass.request("statistics", "user", {userId:student.id
    }).then(response => {
      this.setState({progress:response.courses});
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.student.id !== this.props.student.id) {
      GroupActions.findByUserId(nextProps.student.id);
      CourseActions.findByUserId(nextProps.student.id);

      SteelCompass.request("statistics", "user", {userId:nextProps.student.id
      }).then(response => {
        this.setState({progress:response.courses});
      });
    }
  }

  confirmDelete() {
    this.refs.confirmDialog.show();
  }

  onConfirmRevoke() {
    this.refs.revokeAccessDialog.dismiss();
    StudentActions.removeFromCourse(
      this.state.selectedCourse.id,
      this.props.id,
      () => {
        Message.info(this.context.getIntlMessage('student.revokedAccess'));
        CourseActions.findByUserId(this.props.id);
      }
    );
  }

  revokeAccess() {
    this.refs.revokeAccessDialog.show();
  }

  selectCourse(course) {
    this.setState({ selectedCourse: course });
  }

  closeDetail() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  deleteTag(tagName) {
    StudentActions.removeTag(this.props.student.id, tagName);
  }

  addTag() {
    let tagName = this.refs.addTag.getValue();
    StudentActions.addTag(this.props.student.id, tagName);
    this.refs.addTag.clearValue();
  }

  removeFromGroup(group) {
    this.setState({ selectedGroup: group });
    this.refs.removeFromGroupDialog.show();
  }

  removeFromCourse(course) {
    this.setState({ selectedCourse: course });
    this.refs.removeFromCourseDialog.show();
  }

  _onRemoveFromCourseConfirm() {
    StudentActions.removeFromCourse(
      this.state.selectedCourse.id,
      this.props.student.id
    );
    this.refs.removeFromCourseDialog.dismiss();
  }

  _onRemoveFromGroupConfirm() {
    StudentActions.removeFromGroup(
      this.state.selectedGroup.id,
      this.props.student.id
    );
    this.refs.removeFromGroupDialog.dismiss();
  }

  _onDeleteStudentConfirm() {
    StudentActions.expel(this.state.selectedStudent.id);
    this.refs.removeStudentDialog.dismiss();
    // StudentOverviewActions.getList(this.props.list);
    this.closeDetail();
  }

  addToGroups() {
    this.refs.addToGroupsDialog.show();
  }

  addToCourses() {
    this.refs.addToCoursesDialog.show();
  }

  expelStudent(student) {
    this.setState({ selectedStudent: student });
    this.refs.removeStudentDialog.show();
  }

  changeAccessTime(event, selectedIndex, menuItem) {
    this.setState({ accessTime: menuItem.payload });
  }

  createAddToCoursesDialog() {
    let menuItems = this.menuItems;
    let selectedIndex = menuItems.findIndex(
      item => item.payload === 'sixMonths'
    );
    let actions = [
      { text: this.context.getIntlMessage('Cancel') },
      {
        text: this.context.getIntlMessage('Add'),
        onTouchTap: this._addCoursesConfirm.bind(this),
        ref: 'submit'
      }
    ];
    return (
      <Dialog
        ref="addToCoursesDialog"
        actions={actions}
        actionFocus="submit"
        dismissOnClickAway={true}
        autoDetectWindowHeight={true}
        autoScrollBodyContent={true}
      >
        <DropDown
          onChange={::this.changeAccessTime}
          label={this.context.getIntlMessage('invite.accessTime')}
          ref="courseAccessTime"
          selectedIndex={selectedIndex}
          menuItems={menuItems}
        />
        <CourseSelector ref="courseSelector" />
      </Dialog>
    );
  }

  _addCoursesConfirm() {
    let courseIds = Object.keys(this.refs.courseSelector.getSelected()).map(
      id => parseInt(id, 10)
    );
    let accessTime = this.state.accessTime;
    let userIds = [this.props.student.id];
    InviteActions.inviteByUserIds(userIds, courseIds, accessTime, () => {
      Message.info(
        this.context.getIntlMessage('invite.studentInvitedToCourse')
      );
      this.refs.addToCoursesDialog.dismiss();
      CourseActions.findByUserId(this.props.student.id);
    });
  }

  createAddToGroupsDialog() {
    let actions = [
      { text: this.context.getIntlMessage('Cancel') },
      {
        text: this.context.getIntlMessage('Add'),
        onTouchTap: this._addGroupsConfirm.bind(this),
        ref: 'submit'
      }
    ];

    return (
      <Dialog
        ref="addToGroupsDialog"
        actions={actions}
        actionFocus="submit"
        dismissOnClickAway={true}
        autoDetectWindowHeight={true}
        autoScrollBodyContent={true}
      >
        <GroupSelector ref="groupSelector" />
      </Dialog>
    );
  }

  _addGroupsConfirm() {
    let groupIds = Object.keys(this.refs.groupSelector.getSelected()).map(id =>
      parseInt(id, 10)
    );
    UserActions.addToCircle([this.props.student.id], groupIds, () => {
      Message.info(this.context.getIntlMessage('student.addedToGroup'));
      this.refs.addToGroupsDialog.dismiss();
      GroupActions.findByUserId(this.props.student.id);
    });
  }

  setToggle = (roleMask, event) => {
    let rolesValue = this.props.student.roles;
    const { checked } = event.target;

    if (this._timer) {
      clearTimeout(this._timer);
    }

    this._timer = setTimeout(
      (rolesValue, roleMask) => {
        if (checked) {
          rolesValue.push(roleMask);
        } else {
          var index = rolesValue.indexOf(roleMask);
          if (index > -1) {
            rolesValue.splice(index, 1);
          }
          rolesValue[roleMask] = false;
        }

        this.setState({ rolesValue: rolesValue });

        StudentActions.update(this.props.student.id, rolesValue, () => {
          GroupActions.findByUserId(this.props.student.id);
          CourseActions.findByUserId(this.props.student.id);
        });
        this._timer = null;
      },
      300,
      rolesValue,
      roleMask
    );
  };

  goToCourse = (item) => {
    if (item === null) {
      this.setState({ student: null });
    } else {
      this.props.router.push(`/course/${item.id}`);
    }
  };

  goToGroup = (item) => {
    if (item === null) {
      this.setState({ student: null });
    } else {
      this.props.router.push(`/group/${item.id}`);
    }
  };



  render() {
    var active = this.context.getIntlMessage('student.neverActive'),
      student = this.props.student,
      auth = this.props.auth,
      lastActive = student.lastActive,
      removeFromGroupActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onRemoveFromGroupConfirm.bind(this),
          ref: 'submit'
        }
      ],
      removeFromCourseActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onRemoveFromCourseConfirm.bind(this),
          ref: 'submit'
        }
      ],
      deleteStudentActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onDeleteStudentConfirm.bind(this),
          ref: 'submit'
        }
      ],
      addToCoursesDialog = this.createAddToCoursesDialog(),
      addToGroupsDialog = this.createAddToGroupsDialog();

    if (lastActive && lastActive !== Const.NO_TIME) {
      const lastActiveFixed =
        lastActive && lastActive.split(' ').join('T') + 'Z';
      let lastActiveDate;
      try {
        lastActiveDate = new Date(lastActiveFixed);
        active = (
          <FormattedMessage
            message={this.context.getIntlMessage('student.active')}
            ago={<FormattedRelative value={lastActiveDate} />}
          />
        );
      } catch (e) {
        active = ' ';
      }
    }
    let tags;
    if (student.tagsMap) {
      tags = Object.keys(student.tagsMap).map(tag => {
        if (student.tagsMap[tag])
          return (
            <Tag
              onDelete={this.deleteTag.bind(this)}
              key={tag}
              controls={true}
              mini={false}
              name={tag}
            />
          );
      });
    }
    const roleMap = this.props.student.roles.reduce((map, item) => {
      map[item] = true;
      return map;
    }, {});

    let rolesList;
    if (auth.role.assistant) {
      rolesList = (
        <List
          subheader={this.context.getIntlMessage('Roles')}
          style={{
            marginTop: Spacing.desktopGutter,
            backgroundColor: '#FFFFFF'
          }}
          subheaderStyle={{
            fontSize: 24,
            borderStyle: 'none none solid none',
            borderWidth: '1px',
            borderColor: 'rgba(0, 0, 0, 0.12)'
          }}
        >
          <ListItem
            primaryText={this.context.getIntlMessage('role.reader')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.reader}
                onToggle={this.setToggle.bind(this, 'reader')}
                ref="reader"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.editor')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.editor}
                onToggle={this.setToggle.bind(this, 'editor')}
                ref="editor"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.teacher')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.teacher}
                onToggle={this.setToggle.bind(this, 'teacher')}
                ref="teacher"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.accountant')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.accountant}
                onToggle={this.setToggle.bind(this, 'accountant')}
                ref="accountant"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.owner')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.owner}
                onToggle={this.setToggle.bind(this, 'owner')}
                ref="owner"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.assistant')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.assistant}
                onToggle={this.setToggle.bind(this, 'assistant')}
                ref="assistant"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.tester')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.tester}
                onToggle={this.setToggle.bind(this, 'tester')}
                ref="tester"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.darkAdmin')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.darkAdmin}
                onToggle={this.setToggle.bind(this, 'darkAdmin')}
                ref="darkAdmin"
              />
            }
          />
        </List>
      );
    } else {
      rolesList = (
        <List
          subheader={this.context.getIntlMessage('Roles')}
          style={{
            marginTop: Spacing.desktopGutter,
            backgroundColor: '#FFFFFF'
          }}
          subheaderStyle={{
            fontSize: 24,
            borderStyle: 'none none solid none',
            borderWidth: '1px',
            borderColor: 'rgba(0, 0, 0, 0.12)'
          }}
        >
          <ListItem
            primaryText={this.context.getIntlMessage('role.reader')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.reader}
                onToggle={this.setToggle.bind(this, 'reader')}
                ref="reader"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.teacher')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.teacher}
                onToggle={this.setToggle.bind(this, 'teacher')}
                ref="teacher"
              />
            }
          />
          <ListItem
            primaryText={this.context.getIntlMessage('role.accountant')}
            rightToggle={
              <Toggle
                toggled={!!roleMap.accountant}
                onToggle={this.setToggle.bind(this, 'accountant')}
                ref="accountant"
              />
            }
          />
        </List>
      );
    }

    let toolbar = (
      <Toolbar>
        <ToolbarGroup float={'left'} key={0}>
          <ToolbarTitle text={this.context.getIntlMessage('Student')} />
        </ToolbarGroup>
        <ToolbarGroup float={'right'} key={1}>
          {parseInt(this.props.auth && this.props.auth.id) ===
          parseInt(
            this.state.student &&
              this.state.student.student &&
              this.state.student.student.id
          ) ? null : (
            <ToolbarIconButton
              svgIcon={<MaterialIcons.ActionDelete />}
              tooltip={this.context.getIntlMessage('student.expel')}
              tooltipPosition="bottom-center"
              onTouchTap={this.expelStudent.bind(this, student)}
            />
          )}
          <ToolbarIconButton
            svgIcon={<MaterialIcons.SocialGroupAdd />}
            tooltip={this.context.getIntlMessage('group.add')}
            tooltipPosition="bottom-center"
            onTouchTap={this.addToGroups.bind(this)}
          />
          <ToolbarIconButton
            svgIcon={<CoursioIcons.Library />}
            tooltip={this.context.getIntlMessage('course.add')}
            tooltipPosition="bottom-center"
            onTouchTap={this.addToCourses.bind(this)}
          />
          <ToolbarIconButton
            svgIcon={<MaterialIcons.ContentClear />}
            tooltip={this.context.getIntlMessage('Close')}
            tooltipPosition="bottom-center"
            onTouchTap={this.closeDetail.bind(this)}
          />
        </ToolbarGroup>
      </Toolbar>
    );

    // Remove recently deleted (non-active) courses.
    const courseSelection = this.state.progress.filter(course => !course.ucpInfo.isDeleted);

    return (
      <ScrollableContainer header={toolbar}>
        <List>
          <ListItem
            disabled={true}
            leftIcon={<MaterialIcons.ActionLabel />}
            primaryText={student.name}
          />
          <ListItem
            disabled={true}
            leftIcon={<MaterialIcons.ContentInbox />}
            primaryText={student.email}
          />
          <ListItem
            disabled={true}
            leftIcon={<MaterialIcons.DeviceAccessTime />}
            primaryText={active}
          />
        </List>
        <Overview header={this.context.getIntlMessage('Tags')}>
          <div style={{ padding: Spacing.desktopGutterMini * 2 }}>
            {tags}
            <div>
              <TextField
                fullWidth={true}
                floatingLabelText={this.context.getIntlMessage('tag.add')}
                ref="addTag"
                onEnterKeyDown={this.addTag.bind(this)}
              />
            </div>
          </div>
        </Overview>
        <SimpleOverview
          loading={this.state.group.selectionLoading}
          items={this.state.group.selection}
          readable="name"
          title={this.context.getIntlMessage('group.Groups')}
          onTouchTapRightIcon={this.removeFromGroup.bind(this)}
          onSelect={this.goToGroup}
        />
        <SimpleOverview
          loading={this.state.course.selectionLoading}
          items={courseSelection}
          progress={this.state.progress}
          readable="name"
          title={this.context.getIntlMessage('course.Courses')}
          onTouchTapRightIcon={this.removeFromCourse.bind(this)}
          onSelect={this.goToCourse}
        />
        {rolesList}
        <DialogPortal>
          <Dialog
            ref="removeFromCourseDialog"
            title={this.context.getIntlMessage('student.removeFromCourse')}
            actions={removeFromCourseActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            <FormattedMessage
              message={this.context.getIntlMessage('student.revokeAccess')}
              course={this.state.selectedCourse.name}
              student={this.props.student.name}
            />
          </Dialog>
          <Dialog
            ref="removeFromGroupDialog"
            title={this.context.getIntlMessage('student.removeFromGroupShort')}
            actions={removeFromGroupActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            <FormattedMessage
              message={this.context.getIntlMessage('student.removeFromGroup')}
              group={this.state.selectedGroup.name}
              student={this.props.student.name}
            />
          </Dialog>
          <Dialog
            ref="removeStudentDialog"
            title={this.context.getIntlMessage('student.expel')}
            actions={deleteStudentActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            <FormattedMessage
              message={this.context.getIntlMessage('student.expelConfirm')}
              student={this.state.selectedStudent.name}
            />
          </Dialog>
          {addToCoursesDialog}
          {addToGroupsDialog}
        </DialogPortal>
      </ScrollableContainer>
    );
  }
}

export default withRouter(StudentDetail)



// WEBPACK FOOTER //
// ./src/js/components/Route/Student/Detail.js